export interface FillerVideoListItem {
  id: string;
  name: string;
  categories: string[];
  file_url: string;
  file_en_url?: string | null;
  thumbnail_url?: string | null;
}

/** Lowercase + strip diacritics so "Sabão" matches "sabao" and vice versa. */
export const normalizeSearchText = (text: string): string =>
  text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '');

export interface FillerVideoFilter {
  search?: string;
  /** Tag slug; undefined/empty means all tags. */
  tag?: string;
}

export function filterFillerVideos<T extends FillerVideoListItem>(
  videos: T[],
  { search, tag }: FillerVideoFilter,
): T[] {
  const needle = normalizeSearchText((search ?? '').trim());
  return videos.filter((video) => {
    if (tag && !video.categories.includes(tag)) return false;
    if (needle && !normalizeSearchText(video.name).includes(needle)) return false;
    return true;
  });
}

/** Locale-aware catalog URLs for random fill / export materialization. */
export function fillerCatalogUrls(
  videos: Array<{ file_url: string; file_en_url?: string | null }>,
  language: string,
): string[] {
  const isEnglish = language.toLowerCase().startsWith('en');
  return videos.map((video) => (isEnglish && video.file_en_url) || video.file_url);
}
